import styled from "styled-components"
import {Card, Col} from "@irati/ui/src/Layout"

export const StyledCol = styled(Col)`
  width: 30px;
  margin-right: 15px;
`

export const UnavailableCard = styled(Card)`
  ${({theme}) => `background-color: ${theme.colors.greys.mediumLight};`}
`
